import { Search, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cornicheBackground from '@/assets/corniche-detailed.png';

export function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/opportunities?search=${encodeURIComponent(searchQuery)}`);
  };

  return (
    <section className="relative py-20 md:py-32 overflow-hidden bg-background">
      {/* Corniche Background - More Visible */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-background"></div>
        <img 
          src={cornicheBackground} 
          alt="Brazzaville Corniche" 
          className="absolute inset-0 w-full h-full object-cover opacity-20 animate-fade-in"
          style={{ objectPosition: 'center 0%' }}
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6 animate-fade-in">
            Boostez votre <span className="text-primary">carrière</span> à Brazzaville
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mb-10 animate-fade-in animation-delay-100">
            Des milliers d'opportunités : emplois, stages, bourses et formations
          </p>
          
          {/* Clean Search Bar */}
          <form onSubmit={handleSearch} className="max-w-2xl mx-auto mb-12 animate-fade-in animation-delay-200">
            <div className="flex flex-col md:flex-row gap-3 bg-card p-2 rounded-lg border border-border shadow-sm hover:shadow-md transition-all">
              <div className="relative flex-1">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
                <Input
                  type="text"
                  placeholder="Rechercher une opportunité..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-12 h-12 border-0 bg-transparent focus-visible:ring-1"
                />
              </div>
              <Button type="submit" size="lg" className="h-12 px-8 group">
                <span>Rechercher</span>
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </form>
          
          {/* Simple Stats Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            <div className="bg-card rounded-lg p-6 border border-border hover-lift animate-fade-in animation-delay-100">
              <p className="text-4xl font-bold text-primary mb-1">500+</p>
              <p className="text-sm text-muted-foreground">Opportunités</p>
            </div>
            <div className="bg-card rounded-lg p-6 border border-border hover-lift animate-fade-in animation-delay-200">
              <p className="text-4xl font-bold text-primary mb-1">100+</p>
              <p className="text-sm text-muted-foreground">Entreprises</p>
            </div>
            <div className="bg-card rounded-lg p-6 border border-border hover-lift animate-fade-in animation-delay-300">
              <p className="text-4xl font-bold text-primary mb-1">1000+</p>
              <p className="text-sm text-muted-foreground">Jeunes inscrits</p>
            </div>
            <div className="bg-card rounded-lg p-6 border border-border hover-lift animate-fade-in animation-delay-300">
              <p className="text-4xl font-bold text-primary mb-1">50+</p>
              <p className="text-sm text-muted-foreground">Nouveautés/semaine</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}